__turbopack_context__.v({
  "content": "tabs-module__5y32XW__content",
  "list": "tabs-module__5y32XW__list",
  "trigger": "tabs-module__5y32XW__trigger",
});
